import { create } from '@storybook/theming'

export default create({
  id: 'Labsix',
  base: 'light',
  brandTitle: 'Labsix react-hooks-vimeo',
  brandImage: '/assets/Labsix Logo + name.png',
  brandTarget: '_self',
})
